import qs from 'qs';

import { GetQuotesParams, GetQuotesResponse, GetUserCartsParams, GetUserCartsResponse } from '~/types/services/carts';

import { request } from './common';

function getBaseURL() {
  return `${window.configs.API_HOST}/api/carts`;
}

export async function getCarts(currency, page = 1, limit = 10, brand) {
  const baseURL = getBaseURL();
  const queryParams = {
    currency,
    page,
    limit,
    brand,
  };

  const url = `${baseURL}?${qs.stringify(queryParams)}`;

  return request(url);
}

export async function getUserQuotes(customerId: string, page = 1, limit = 10) {
  const baseURL = getBaseURL();
  const queryParams = {
    page,
    limit,
  };

  const url = `${baseURL}/quotes/${customerId}?${qs.stringify(queryParams)}`;

  return request(url, {
    method: 'GET',
  });
}

export async function getQuotes(
  { page = 1, limit = 10, brand, agentId, createdFrom, createdTo }: GetQuotesParams,
  options?: { signal?: AbortSignal },
): Promise<GetQuotesResponse> {
  const baseURL = getBaseURL();
  const queryParams = {
    page,
    limit,
    brand,
    agentId,
    createdFrom,
    createdTo,
  };

  const url = `${baseURL}/quotes?${qs.stringify(queryParams, { skipNulls: true })}`;

  return request(url, {
    method: 'GET',
    ...(options?.signal ? { signal: options.signal } : {}),
  });
}

export async function getCartsByUser(
  userId: string,
  params: GetUserCartsParams,
  options?: { signal?: AbortSignal },
): Promise<GetUserCartsResponse> {
  const baseURL = getBaseURL();
  const query = qs.stringify(params, { arrayFormat: 'brackets', skipNulls: true });
  const url = `${baseURL}/user/${userId}${query ? `?${query}` : ''}`;

  return request(url, {
    method: 'GET',
    ...(options?.signal ? { signal: options.signal } : {}),
  });
}

export async function getTermsAndConditions(orderId: string) {
  const baseURL = getBaseURL();
  const queryParams = qs.stringify({
    orderId,
  });
  const url = `${baseURL}/v1/terms-and-conditions?${queryParams}`;

  return request(url, {
    method: 'GET',
  });
}
